import {
	getOrderDetail,
} from '@/api/order.js';
import Pagination from '@/components/Pagination';
import router from '../../../router';
let _this;
export default {
	name: 'framework',
	components: {
		Pagination
	},
	data() {
		return {
			orderObj: { //订单列表
				info: [],
				listLoading: false,
			},
		}
	},
	beforeCreate() {
		_this = this;
	},
	filters: {
		rechargeChannelFilter(type) { //充值渠道
			return _this.$constant.RECHARGE_CHANNEL[type]
		},
		OrderStatusFilter(type) { //订单状态
			return _this.$constant.ORDER_STATUS[type]
		},
		OrderTypeFilter(type){ //订单类型
			return _this.$constant.ORDER_TYPE[type]
		},
		RefundStatusFilter(type){//退款状态
			return _this.$constant.REFUND_STATUS[type]
		},
		SubmitStatusFilter(type){ //是否提交
			return _this.$constant.SUBMIT_STATUS[type]
		},
		StatusTypeFilter(type){//是否状态
			return _this.$constant.STATUS_TYPE[type]
		},
		
	},
	created() {
		this.getOrderDetail(this.$route.query.id)
	},
	methods: {
		//获取订单详情
		getOrderDetail(id) {
			let _this = this;
			this.orderObj.listLoading = true;
			//获取订单列表
			getOrderDetail({orderId: id}).then(res => {
				_this.orderObj.info = res.data;
				_this.orderObj.listLoading = false;
			})
		},

		goBack() {
			this.$router.go(-1)
		},
	}
}
